<div class="login-main-container">
    <div class="help-link-contact">
        <div class="headerbar-right">
            <app-language-dropdown></app-language-dropdown>
            <a class="help-link" [href]="brand.helpUrl" target="_blank">{{
                'help' | translate 
                }}</a>
        </div>
    </div>
    <div class="login-container">
        <div class="login-sub-container">
            <div class="text-center login-text">
                <img *ngIf="brand.id" [src]="brand.logoPath" class="login-w-image" alt="{{ brand.name }}" />
            </div>
            <div class="text-center login-heading">
                {{ 'login' | translate  }}
            </div>
            <div class="login-message text-center">
                {{ 'loginWithYourCredentials' | translate  }}
            </div>
            <div class="form-group input-login-details email-input-container">
                <label for="url" [ngClass]="{
            'login-label-error': errorMessage.url,
            'login-label': !errorMessage.url
          }">{{ 'url' | translate  }}</label>
                <div class="domain-url-input-group">
                    <div class="url-input-group">
                        <input type="text" class="form-control url-input" [ngClass]="{
                'url-input': !errorMessage.url,
                'url-input-error': errorMessage.url
              }" id="schoolUrl" name="schoolUrl" placeholder="{{ 'enterUrl' | translate  }}" minlength="2" maxlength="15"
                            autocomplete="off" [(ngModel)]="schoolUrl" #url (input)="handleDebounceUrl(url)"
                            (keyup.enter)="handleContinue()" />
                        <span [ngClass]="{
                'input-addon': !errorMessage.url,
                'input-addon-error': errorMessage.url
              }">.{{ brand.domainSuffix }}</span>
                    </div>
                    <div class="error-message">
                        <span *ngIf="errorMessage.url"> {{ errorMessage.url }}</span>
                    </div>
                </div>
            </div>
            <div class="login-btn text-center">
                <button class="btn btn-otp" type="submit" [disabled]="loader" (click)="handleContinue()">
                    <ng-container *ngIf="loader; else notLoading">
                        <app-button-loader></app-button-loader>
                    </ng-container>
                    <ng-template #notLoading>{{ 'continue' | translate  }}</ng-template>
                </button>
            </div>
            <div class="text-center login-link">
                <span>{{ 'forgotSchoolURL' | translate  }} </span><span class="login-url-links"
                    (click)="onLoginWithEmailIdClicked()">{{
                    'loginWithEmailId' | translate 
                    }}</span>
            </div>
            <div class="text-center login-link">
                <span>{{ 'notRegistered' | translate  }} </span><span class="login-url-links"
                    (click)="openRegisterLink()">{{
                    'register' | translate 
                    }}</span>
            </div>
        </div>
    </div>
</div>